<template>
  <b-card class="text-center">
    <template #header>
      Recognition
    </template>
    <p class="p-3 pb-4">
      If you want to ask people to recognize you, you can ask them to give you kudos.
    </p>
    <template #footer>
      <div class="mb-3">
        <b-button pill variant="primary" class="w-max-200 w-100" @click="modalShow = !modalShow">
          Ask for recognition
        </b-button>
      </div>
    </template>
    <b-modal v-model="modalShow" hide-footer title="Ask For Recognition">
      <div class="text-center p-5">
        <p>Enter the email adresses below.</p>
        <p class="mx-0 mx-md-5">
          Recipients will receive a temporary access to Good4work and will be able to leave you kudos.
        </p>
      </div>
      <ask-recognition-form :submitting="submitting" :state="state" @submit="onInvite" />
    </b-modal>
  </b-card>
</template>

<script>
import AskRecognitionForm from '@/components/forms/AskRecognitionForm.vue'
import { AppName } from '@/helpers/constants'

export default {
  name: 'AskRecognition',

  data() {
    return {
      AppName,
      modalShow: false,
      submitting: false,
      state: {}
    }
  },

  methods: {
    onInvite(data) {
      this.submitting = true
      this.$store.dispatch('recognitionInvite', data)
        .then(() => (this.modalShow = false))
        .catch(error => (this.state = error))
        .finally(() => (this.submitting = false))
    }
  },

  components: {
    AskRecognitionForm
  }
}
</script>
